<template>
  <window-portal :open="dataProps.show" @close="onClose()">
    <preview-document :config="previewConfig">
      <template #pages="{ config }">
        <preview-page
          v-for="(pageData, pIndex) in pagesData"
          :key="`page-${pIndex}`"
          :config="config"
        >
          <!-- Header -->
          <template #header>
            <div
              style="
                text-align: center;
                font-size: 15px;
                font-weight: bold;
                margin-bottom: 20px;
              "
            >
              MOVIMIENTO DE VENTAS DEL {{ formatDateToDDMMYYYYStart }} AL
              {{ formatDateToDDMMYYYYEnd }}
            </div>
          </template>
          <!-- body -->
          <div>
            <!-- <pre style="font-size: 10pt">{{ pageData }}</pre> -->
            <table
              style="font-size: 8pt; width: 100%; border-collapse: collapse"
            >
              <thead>
                <tr>
                  <th
                    style="
                      border-style: solid;
                      border-color: black;
                      border-width: 1px 0px 1px 0px;
                      padding: 5px;
                    "
                  >
                    Correlativo
                  </th>
                  <th
                    style="
                      border-style: solid;
                      border-color: black;
                      border-width: 1px 0px 1px 0px;
                      padding: 5px;
                    "
                  >
                    Forma
                  </th>
                  <th
                    style="
                      border-style: solid;
                      border-color: black;
                      border-width: 1px 0px 1px 0px;
                      padding: 5px;
                    "
                  >
                    Fecha
                  </th>
                  <th
                    style="
                      border-style: solid;
                      border-color: black;
                      border-width: 1px 0px 1px 0px;
                      padding: 5px;
                    "
                  >
                    Nombre Cliente
                  </th>
                  <th
                    style="
                      border-style: solid;
                      border-color: black;
                      border-width: 1px 0px 1px 0px;
                      padding: 5px;
                    "
                  >
                    Valor Gravado
                  </th>
                  <th
                    style="
                      border-style: solid;
                      border-color: black;
                      border-width: 1px 0px 1px 0px;
                      padding: 5px;
                    "
                  >
                    Valor Exento
                  </th>
                  <th
                    style="
                      border-style: solid;
                      border-color: black;
                      border-width: 1px 0px 1px 0px;
                      padding: 5px;
                    "
                  >
                    IVA
                  </th>
                  <th
                    style="
                      border-style: solid;
                      border-color: black;
                      border-width: 1px 0px 1px 0px;
                      padding: 5px;
                    "
                  >
                    Total
                  </th>
                  <th
                    style="
                      border-style: solid;
                      border-color: black;
                      border-width: 1px 0px 1px 0px;
                      padding: 5px;
                    "
                  >
                    Ret. IVA
                  </th>
                  <th
                    style="
                      border-style: solid;
                      border-color: black;
                      border-width: 1px 1px 1px 0px;
                      padding: 5px;
                    "
                  >
                    Usuario
                  </th>
                </tr>
              </thead>
              <tbody style="text-align: center">
                <tr
                  v-for="(row, rIndex) in pageData"
                  :key="`row-${pIndex}-${rIndex}`"
                  style="vertical-align: top"
                >
                  <template v-if="row.type === 'record'">
                    <td style="padding: 5px; height: 52px; text-align: left">
                      {{ row.data.ID_Invoice }}
                    </td>
                    <td style="padding: 5px; text-align: left">
                      {{ row.data.DescPaymentType?.replaceAll('_', ' ') }}
                    </td>
                    <td style="padding: 5px; text-align: left">
                      {{ row.data.InvoiceDate }}
                    </td>
                    <td style="padding: 5px; text-align: left">
                      {{ row.data.InvoiceName }}
                    </td>
                    <td style="text-align: right; padding: 5px">
                      {{ parseWithCurrency(row.data.gravada), }}
                    </td>
                    <td style="text-align: right; padding: 5px">
                      {{ parseWithCurrency(row.data.InvoiceTotalExentaFormatted) }}
                    </td>
                    <td style="text-align: right; padding: 5px">
                      {{ parseWithCurrency(row.data.IVA) }}
                    </td>
                    <td style="text-align: right; padding: 5px">
                      {{ row.data.Total }}
                    </td>
                    <td style="text-align: right; padding: 5px">
                      {{ parseWithCurrency(row.data.InvoiceIvaRete1) }}
                    </td>
                    <td style="padding: 5px">{{ row.data.UserName }}</td>
                  </template>
                  <td
                    v-else-if="row.type === 'prefixHeader'"
                    colspan="11"
                    style="
                      text-align: left;
                      font-weight: bold;
                      border-bottom: 1px solid black;
                      padding: 5px;
                    "
                  >
                    {{ row.title }}
                  </td>

                  <template v-else-if="row.type === 'emptyLine'">
                    <td><br></td>
                  </template>

                  <td
                    v-else-if="row.type === 'totalesHeader'"
                    colspan="12"
                    style="
                      text-align: left;
                      font-weight: bold;
                      border-bottom: 1px solid black;
                      padding: 5px;
                    "
                  >
                    TOTAL GLOBAL
                  </td>

                  <template v-else-if="row.type === 'totalGrupo'">
                    <td
                      colspan="5"
                      style="
                        border-style: solid;
                        border-color: black;
                        border-width: 1px 0px 0px 1px;
                        padding: 5px;
                        text-align: right;
                      "
                    >
                      Total {{row.global ? '' : 'grupo'}} $
                    </td>
                    <td
                      style="
                        border-style: solid;
                        border-color: black;
                        border-width: 1px 0px 0px 0px;
                        padding: 5px;
                        text-align: right;
                      "
                    >
                    <b v-if="row.global">
                      {{ row.data.totalGroup.toFixed(2) }}
                    </b>
                    <span v-else>
                      {{ row.data.totalGroup.toFixed(2) }}
                    </span>
                    </td>
                    <td
                      style="
                        border-style: solid;
                        border-color: black;
                        border-width: 1px 0px 0px 0px;
                        padding: 5px;
                        text-align: right;
                      "
                    >
                    <b v-if="row.global">
                      ${{ row.data.totalExento.toFixed(2) }}
                    </b>
                    <span v-else>
                      ${{ row.data.totalExento.toFixed(2) }}
                    </span>
                    </td>
                    <td
                      style="
                        border-style: solid;
                        border-color: black;
                        border-width: 1px 0px 0px 0px;
                        padding: 5px;
                        text-align: right;
                      "
                    >
                    <b v-if="row.global">
                      ${{ row.data.totalIVA.toFixed(2) }}
                    </b>
                    <span v-else>
                      ${{ row.data.totalIVA.toFixed(2) }}
                    </span>
                    </td>
                    <td
                      style="
                        border-style: solid;
                        border-color: black;
                        border-width: 1px 0px 0px 0px;
                        padding: 5px;
                        text-align: right;
                      "
                    >
                    <b v-if="row.global">
                      ${{ row.data.totalFactura.toFixed(2) }}
                    </b>
                    <span v-else>
                      ${{ row.data.totalFactura.toFixed(2) }}
                    </span>
                    </td>
                    <td
                      style="
                        border-style: solid;
                        border-color: black;
                        border-width: 1px 0px 0px 0px;
                        padding: 5px;
                        text-align: right;
                      "
                    >
                    <b v-if="row.global">
                      ${{ row.data.totalReteIVA.toFixed(2) }}
                    </b>
                    <span v-else>
                      ${{ row.data.totalReteIVA.toFixed(2) }}
                    </span>
                    </td>
                    <td
                      style="
                        border-style: solid;
                        border-color: black;
                        border-width: 1px 1px 0px 0px;
                        padding: 5px;
                        text-align: right;
                      "
                    ></td>
                  </template>
                  <template v-else-if="row.type === 'totales'">
                    <td
                      colspan="11"
                      style="
                        border-style: solid;
                        border-color: black;
                        border-width: 0px 1px 1px 1px;
                      "
                    >
                      <div style="display: flex">
                        <div
                          style="
                            width: 33.3333%;
                            display: flex;
                            justify-content: space-around;
                            padding: 5px;
                          "
                        >
                          <span>{{row.global ? 'Contado' : 'Subtotal contado'}} $ 
                            <b v-if="row.global">
                              {{ row.data.subtotalContado.toFixed(2) }}
                            </b>
                            <span v-else>
                              {{ row.data.subtotalContado.toFixed(2) }}
                            </span>
                          </span>
                        </div>
                        <div
                          style="
                            width: 33.3333%;
                            display: flex;
                            justify-content: space-around;
                            padding: 5px;
                          "
                        >
                          <span>{{row.global ? 'Cheque' : 'Subtotal cheque'}} $ 
                            <b v-if="row.global">
                              {{ row.data.subtotalCheque.toFixed(2) }}
                            </b>
                            <span v-else>
                              {{ row.data.subtotalCheque.toFixed(2) }}
                            </span>
                          </span>
                        </div>
                        <div
                          style="
                            width: 33.3333%;
                            display: flex;
                            justify-content: space-around;
                            padding: 5px;
                          "
                        >
                          <span>{{row.global ? 'Transferencia' : 'Subtotal transferencia'}} $ 
                            <b v-if="row.global">
                              {{ row.data.subtotalTransferencia.toFixed(2) }}
                            </b>
                            <span v-else>
                              {{ row.data.subtotalTransferencia.toFixed(2) }}
                            </span>
                          </span>
                        </div> 
                      </div>
                      <!-- segunda linea total -->
                      <div style="display: flex">
                        <div
                          style="
                            width: 33.3333%;
                            display: flex;
                            justify-content: space-around;
                            padding: 5px;
                          "
                        >
                          <span>{{row.global ? 'Crédito' : 'Subtotal crédito'}} crédito $ 
                            <b v-if="row.global">
                              {{ row.data.subtotalCredito.toFixed(2) }}
                            </b>
                            <span v-else>
                              {{ row.data.subtotalCredito.toFixed(2) }}
                            </span>
                          </span>
                        </div>
                        <div
                          style="
                            width: 33.3333%;
                            display: flex;
                            justify-content: space-around;
                            padding: 5px;
                          "
                        >
                          <span>{{row.global ? 'Tarjeta' : 'Subtotal tarjeta'}} $ 
                            <b v-if="row.global">
                              {{ row.data.subtotalTarjeta.toFixed(2) }}
                            </b>
                            <span v-else>
                              {{ row.data.subtotalTarjeta.toFixed(2) }}
                            </span>
                          </span>
                        </div>
                        <div
                          style="
                            width: 33.3333%;
                            display: flex;
                            justify-content: space-around;
                            padding: 5px;
                          "
                        >
                          <span>{{row.global ? 'Otros' : 'Subtotal otros'}} $ 
                            <b v-if="row.global">
                              {{ row.data.totalOtros.toFixed(2) }}
                            </b>
                            <span v-else>
                              {{ row.data.totalOtros.toFixed(2) }}
                            </span>
                          </span>
                        </div>
                      </div>
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Footer -->
          <template #footer>
            <p style="font-size: 10px">
              Pagina {{ pIndex + 1 }} de {{ totalPages }}
            </p>
          </template>
        </preview-page>
      </template>
    </preview-document>
  </window-portal>
</template>

<script>
import jsPDF from "jspdf";
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue";
import PreviewDocument from "@/components/PreviewDocument/PreviewDocument.vue";
import PreviewPage from "@/components/PreviewDocument/PreviewPage.vue";

export default {
  name: "PrintCutCashierV2",
  props: {
    dataProps: {
      type: Object,
    },
    hideQr: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    event: "update",
    prop: "dataProps",
  },
  components: { WindowPortal, PreviewDocument, PreviewPage },
  data() {
    return {
      previewConfig: {
        title: "Vista Previa Reporte de Corte de Caja",
        filename: "ReporteCorteCaja.pdf",
        margins: [10, 10, 10, 10],
        unit: "mm",
        format: "letter",
        orientation: "portrait",
      },
      pagesData: [[]],
      maxRowsPerPage: 17,
      loading: false,
      numPages: 0,
      valuesRows: [],
      subTotal: 0,
      totalIngresos: 0,
      totalCredito: 0,
      totalEgresos: 0,
      total: 0,
      totalInvalidado: 0,
      totalContadoGeneral: 0,
      totalInvalidadoGeneral: 0,
      totalCreditoGeneral: 0,
      totalAbonoGeneral: 0,
      totalBillsAndCoins: 0,
      totalCards: 0,
      totalCheck: 0,
      totalTransfer: 0,
      totalOthers: 0,
      totalBillsAndCoinsGeneral: 0,
      totalCardsGeneral: 0,
      totalCheckGeneral: 0,
      totalTransferGeneral: 0,
      totalOthersGeneral: 0,
      totalDebitCard: 0,
      totalCreditCard: 0,

      totalBillsAndCoinsAnticipo: 0,
      totalCardsAnticipo: 0,
      totalTransferAnticipo: 0,
      totalCheckAnticipo: 0,
      totalAnticipos: 0,
      totalBillsAndCoinsAbonos: 0,
      totalCardsAbonos: 0,
      totalTransferAbonos: 0,
      totalCheckAbonos: 0,
      totalAbonos: 0,
    };
  },
  mounted() {},
  computed: {
    totalPages() {
      return this.pagesData.length;
    },
    pages() {
      // Generar un arreglo con `numPages` elementos
      return Array.from({ length: this.numPages });
    },
    formatDateToDDMMYYYYStart() {
      const dateStr = this.dataProps.data.dates.start;

      if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
          return dateStr;
      }

      // Si la fecha está en formato YYYY-MM-DD
      const parts = dateStr.split('-');
      if (parts.length === 3) {
          const [year, month, day] = parts.map(Number);
          const d = new Date(year, month - 1, day);
          if (isNaN(d.getTime())) {
              return 'Fecha inválida'; 
          }   
          const dayStr = d.getDate().toString().padStart(2, '0');
          const monthStr = (d.getMonth() + 1).toString().padStart(2, '0');
          return `${dayStr}/${monthStr}/${year}`;
      }

      return this.dataProps.data.dates.start;
    },
    formatDateToDDMMYYYYEnd() {
      const dateStr = this.dataProps.data.dates.end;

      if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
          return dateStr;
      }

      // Si la fecha está en formato YYYY-MM-DD
      const parts = dateStr.split('-');
      if (parts.length === 3) {
          const [year, month, day] = parts.map(Number);
          const d = new Date(year, month - 1, day);
          if (isNaN(d.getTime())) {
              return 'Fecha inválida'; 
          }   
          const dayStr = d.getDate().toString().padStart(2, '0');
          const monthStr = (d.getMonth() + 1).toString().padStart(2, '0');
          return `${dayStr}/${monthStr}/${year}`;
      }

      return this.dataProps.data.dates.end;
    },
  },
  watch: {
    "dataProps.show"() {
      if (this.dataProps.show) {
        this.paginateData();
      }
    },
  },
  methods: {
    parseWithCurrency(value, isInteger = true) {
      const currency = JSON.parse(localStorage.getItem("branch")).Currency;
      
      let number = isInteger ? parseInt(value) : parseFloat(value); 

      if (isNaN(number)) {
        console.log('parseWithCurrency: Value not a number');
        return `${currency} 0.00`;
      }

      number = number.toFixed(2);

      return `${currency} ${number}`; 
    },
    splitCode(code) {
      const regex = /^([A-Za-z]+)(\d+)$/;
      const resultado = code.match(regex);

      if (!resultado) {
        throw new Error(
          "El código no tiene el formato esperado: prefijo letras + consecutivo números"
        );
      }
      const [, prefijo, consecutivo] = resultado;
      return { prefijo, consecutivo };
    },
    onClose() {
      const data = this.$clone(this.dataProps);
      data.show = false;
      this.$emit("update", data);
    },
    getCurrentPage(nextRecords = 1) {
      const page = this.pagesData[this.pagesData.length - 1];
      if (page.length + nextRecords <= this.maxRowsPerPage) {
        return page;
      } else {
        this.pagesData.push([]);
        return this.pagesData[this.pagesData.length - 1];
      }
    },
    calcTotalPrefijo() {
      // console.log('arrayData', arrayData);
      const totals = {
        totalGroup: 0,
        totalExento: 0,
        totalIVA: 0,
        totalFactura: 0,
        totalReteIVA: 0,
        subtotalContado: 0,
        subtotalCheque: 0,
        subtotalTransferencia: 0,
        subtotalCredito: 0,
        subtotalTarjeta: 0,
        subtotalConsumo: 0,
        totalEgresos: 0,
        totalOtros: 0,
      };

      let tableData = this.dataProps.data.body

      tableData.sort((a, b) => a.ID_Invoice.localeCompare(b.ID_Invoice));

      let nonExpenses = []
      let expenses = []

      for (const item of tableData) {
        if (item.ID_Invoice.includes("DNC") || item.InvoiceStatusDescription.includes("INVALIDADO")
        ) {
          item.isExpense = true;
          expenses.push(item)
        } else {
          nonExpenses.push(item)
        }
      }

      tableData = [
        ...nonExpenses,
        ...expenses
      ];

      for (const item of tableData) {

        totals.totalExento += parseFloat(item.InvoiceTotalExenta);
        totals.totalIVA += parseFloat(item.Iva);
        totals.totalReteIVA += parseFloat(item.InvoiceIvaRete1);

        if (
          item.ID_Invoice.includes("FNS") ||
          item.ID_Invoice.includes("DNC") ||
          item.ID_Invoice.includes("DND") ||
          item.InvoiceStatusDescription.includes("INVALIDADO")
        ) {
          if (!item.InvoiceStatusDescription.includes("INVALIDADO")) {
            totals.totalEgresos += Math.abs(
              parseFloat(item.Total.replace(/[$,]/g, ""))
            );
          } else {
            totals.totalEgresos += Math.abs(
              parseFloat(
                (
                  (item.sum === 1 && item.abonado === 0
                    ? item.Total
                    : `${item.abonado}`) ?? 0
                ).replace(/[$,]/g, "")
              )
            );
          }
        }
        if( item.InvoiceStatusDescription != 'INVALIDADO' ) {
          if (item.DescPaymentType == "Billetes y monedas") {
            totals.totalGroup += parseFloat(item.TotalSale);
          } else if (
            ["Tarjeta Débito", "Tarjeta Crédito", 'Tarjeta de crédito / Débito'].includes(item.DescPaymentType)
          ) {
            // if (item.DescPaymentType === "Tarjeta Débito") {
            //   this.totalDebitCard += parseFloat(item.TotalSale);
            // } else {
            //   this.totalCreditCard += parseFloat(item.TotalSale);
            // }
            totals.totalGroup += parseFloat(item.TotalSale);
          } else if (item.DescPaymentType == "Cheque") {
            totals.totalGroup += parseFloat(item.TotalSale);
          } else if (item.DescPaymentType == "Transferencia_ Depósito Bancario") {
            totals.totalGroup += parseFloat(item.TotalSale);
          } else {
            if(item.InvoiceStatusDescription != "ANTICIPO" && item.InvoiceStatusDescription != "ABONO") {
              totals.totalOtros += parseFloat(item.TotalSale);
            }
          }
        }

        if (item.DescPaymentType == "Billetes y monedas") {
          totals.subtotalContado += parseFloat(item.TotalSale);
        }

        if (item.DescPaymentType == "Cheque") {
          totals.subtotalCheque += parseFloat(item.TotalSale);
        }

        if (
            item.DescPaymentType == "Transferencia_ Depósito Bancario"
          ) {
            totals.subtotalTransferencia += parseFloat(item.TotalSale);
          }

        if (
          ["Tarjeta Débito", "Tarjeta Crédito", 'Tarjeta de crédito / Débito'].includes(item.DescPaymentType)
        ) {
          if (item.DescPaymentType === "Tarjeta Débito") {
            this.totalDebitCard += parseFloat(item.TotalSale);
          } else {
            this.totalCreditCard += parseFloat(item.TotalSale);
          }
          totals.subtotalTarjeta += parseFloat(item.TotalSale);
        }

        if (
          (item.ID_Invoice.includes("FCF") ||
            item.ID_Invoice.includes("CCF") ||
            item.ID_Invoice.includes("FEX") ||
            item.ID_Invoice.includes("RCIB")) &&
          item.InvoiceStatusDescription == "Crédito"
        ) {
          totals.subtotalCredito += parseFloat(item.Total.replace(/[$,]/g, ""));
        }
      }
      totals.totalFactura = parseFloat(totals.totalGroup - totals.totalEgresos);
      for (const key in totals) {
          totals[key] = parseFloat(totals[key].toFixed(2))
      }

      return totals;
    },
    paginateData() {
      // let num = 0;
      this.pagesData = [[]];
      const data_ = [];

      this.dataProps.data.body.sort((a, b) => a.ID_Invoice.localeCompare(b.ID_Invoice));
      let tableData = this.dataProps.data.body

      tableData.sort((a, b) => a.ID_Invoice.localeCompare(b.ID_Invoice));

      let nonExpenses = []
      let expenses = []

      for (const item of tableData) {
        if (item.ID_Invoice.includes("DNC") || item.InvoiceStatusDescription.includes("INVALIDADO")
        ) {
          item.isExpense = true;
          expenses.push(item)
        } else {
          nonExpenses.push(item)
        }
      }

      tableData = [
        ...nonExpenses,
        ...expenses
      ];

      const totals = {
        totalGroup: 0,
        totalExento: 0,
        totalIVA: 0,
        totalFactura: 0,
        totalReteIVA: 0,
        subtotalContado: 0,
        subtotalCheque: 0,
        subtotalTransferencia: 0,
        subtotalCredito: 0,
        subtotalTarjeta: 0,
        subtotalConsumo: 0,
        totalEgresos: 0,
        totalOtros: 0,
      };
      for (const item of tableData) {
        const { prefijo, consecutivo } = this.splitCode(item.ID_Invoice);

        data_.push({ ...item, prefijo, consecutivo });

        totals.totalExento += parseFloat(item.InvoiceTotalExenta);
        totals.totalIVA += parseFloat(item.Iva);
        totals.totalReteIVA += parseFloat(item.InvoiceIvaRete1);

        if (
          item.ID_Invoice.includes("FNS") ||
          item.ID_Invoice.includes("DNC") ||
          item.ID_Invoice.includes("DND") ||
          item.InvoiceStatusDescription.includes("INVALIDADO")
        ) {
          if (!item.InvoiceStatusDescription.includes("INVALIDADO")) {
            totals.totalEgresos += Math.abs(
              parseFloat(item.Total.replace(/[$,]/g, ""))
            );
          } else {
            totals.totalEgresos += Math.abs(
              parseFloat(
                (
                  (item.sum === 1 && item.abonado === 0
                    ? item.Total
                    : `${item.abonado}`) ?? 0
                ).replace(/[$,]/g, "")
              )
            );
          }
        }

        if( item.InvoiceStatusDescription != 'INVALIDADO' ) {
          if (item.DescPaymentType == "Billetes y monedas") {
            totals.totalGroup += parseFloat(item.TotalSale);
          } else if (
            ["Tarjeta Débito", "Tarjeta Crédito", 'Tarjeta de crédito / Débito'].includes(item.DescPaymentType)
          ) {
            // if (item.DescPaymentType === "Tarjeta Débito") {
            //   this.totalDebitCard += parseFloat(item.TotalSale);
            // } else {
            //   this.totalCreditCard += parseFloat(item.TotalSale);
            // }
            totals.totalGroup += parseFloat(item.TotalSale);
          } else if (item.DescPaymentType == "Cheque") {
            totals.totalGroup += parseFloat(item.TotalSale);
          } else if (item.DescPaymentType == "Transferencia_ Depósito Bancario") {
            totals.totalGroup += parseFloat(item.TotalSale);
          } else {
            if(item.InvoiceStatusDescription != "ANTICIPO" && item.InvoiceStatusDescription != "ABONO") {
              // console.log('item.TotalSale2',  num, item.TotalSale);
              totals.totalOtros += parseFloat(item.TotalSale);
              // num+=1;
            }
          }
        }

        if (item.DescPaymentType == "Billetes y monedas") {
          totals.subtotalContado += parseFloat(item.TotalSale);
        }

        if (item.DescPaymentType == "Cheque") {
          totals.subtotalCheque += parseFloat(item.TotalSale);
        }

        if (
            item.DescPaymentType == "Transferencia_ Depósito Bancario"
          ) {
            totals.subtotalTransferencia += parseFloat(item.TotalSale);
          }

        if (
          ["Tarjeta Débito", "Tarjeta Crédito", 'Tarjeta de crédito / Débito'].includes(item.DescPaymentType)
        ) {
          if (item.DescPaymentType === "Tarjeta Débito") {
            this.totalDebitCard += parseFloat(item.TotalSale);
          } else {
            this.totalCreditCard += parseFloat(item.TotalSale);
          }
          totals.subtotalTarjeta += parseFloat(item.TotalSale);
        }

        if (
          (item.ID_Invoice.includes("FCF") ||
            item.ID_Invoice.includes("CCF") ||
            item.ID_Invoice.includes("FEX") ||
            item.ID_Invoice.includes("RCIB")) &&
          item.InvoiceStatusDescription == "Crédito"
        ) {
          totals.subtotalCredito += parseFloat(item.Total.replace(/[$,]/g, ""));
        }
      }

      totals.totalFactura = parseFloat(totals.totalGroup - totals.totalEgresos);
      // console.log(totals.totalEgresos);

      data_.sort((item1, item2) => item1.prefijo > item2.prefijo);
      let lastPrefijo = null;
      const prefixHeaders = new Set();

      // console.log('data_', data_);

      for (const item of data_) {
        let page = this.getCurrentPage();
        if (!page.length) {
          prefixHeaders.clear();
        }

        // Si el prefijo actual es diferente al último prefijo visto y no es la primera iteración
        if (lastPrefijo !== null && item.prefijo !== lastPrefijo) {
          page = this.getCurrentPage(2);
          page.push({ type: `totalGrupo`, 
            title: `Total de ${this.documentTypeByPrefix(lastPrefijo)}`, 
            data: this.calcTotalPrefijo(data_.filter(data => data.prefijo === lastPrefijo))}); // Inserta el objeto separador
          page.push({ type: "totales", data: this.calcTotalPrefijo(data_.filter(data => data.prefijo === lastPrefijo)) });
          page.push({ type: `emptyLine` });
        }
        if (!prefixHeaders.has(item.prefijo)) {
          prefixHeaders.add(item.prefijo);
          page = this.getCurrentPage(2);
          page.push({ type: "prefixHeader", title: this.documentTypeByPrefix(item.prefijo) });
        }
        page.push({ type: "record", data: item });
        lastPrefijo = item.prefijo; // Actualiza el último prefijo
      }
      if (lastPrefijo !== null) {
        const page = this.getCurrentPage(2);
        page.push({ type: `totalGrupo`, 
          title: `Total de ${this.documentTypeByPrefix(lastPrefijo)}`, 
          data: this.calcTotalPrefijo(data_.filter(data => data.prefijo === lastPrefijo))}); // Inserta el objeto separador
        page.push({ type: "totales", data: this.calcTotalPrefijo(data_.filter(data => data.prefijo === lastPrefijo)) });
        // page.push({ type: `emptyLine` });
      }
      const page = this.getCurrentPage(2);
      // totals.subtotalConsumo = totals.totalGroup + totals.subtotalCredito + totals.totalOtros;

      for (const key in totals) {
          totals[key] = parseFloat(totals[key].toFixed(2))
      }
      page.push({ type: `emptyLine` });
      page.push({ type: "totalesHeader" });
      page.push({ type: "totalGrupo", data: totals, global: true });
      page.push({ type: "totales", data: totals, global: true });
    },
    calculateTotalsCashierCut(body) {
      try {
        this.totalContadoGeneral = 0;
        this.totalAbonoGeneral = 0;
        this.totalInvalidadoGeneral = 0;
        this.totalCreditoGeneral = 0;
        this.totalBillsAndCoinsGeneral = 0;
        this.totalCardsGeneral = 0;
        this.totalCheckGeneral = 0;
        this.totalTransferGeneral = 0;
        this.totalOthersGeneral = 0;
        this.totalCreditCard = 0;
        this.totalDebitCard = 0;

        this.totalBillsAndCoinsAnticipo = 0;
        this.totalCardsAnticipo = 0;
        this.totalTransferAnticipo = 0;
        this.totalCheckAnticipo = 0;
        this.totalAnticipos = 0;
        this.totalBillsAndCoinsAbonos = 0;
        this.totalCardsAbonos = 0;
        this.totalTransferAbonos = 0;
        this.totalCheckAbonos = 0;

        const billsAndCoinsAnticipoType = ["Billetes y monedas", "Efectivo",'Tarjeta de crédito / Débito'];
        const cardsType = [
          "Tarjeta Débito",
          "Tarjeta de crédito",
          "Tarjeta Crédito",
          'Tarjeta de crédito / Débito'
        ];
        const transfersType = [
          "Transferencia bancaria",
          "Transferencia_ Depósito Bancario",
        ];

        body.forEach((item) => {
          if (
            item.InvoiceStatusDescription == "ANTICIPO" &&
            billsAndCoinsAnticipoType.includes(item.DescPaymentType)
          ) {
            this.totalBillsAndCoinsAnticipo += parseFloat(
              item.Total.replace(/[$,]/g, "")
            );
          }
          if (
            item.InvoiceStatusDescription == "ANTICIPO" &&
            cardsType.includes(item.DescPaymentType)
          ) {
            this.totalCardsAnticipo += parseFloat(
              item.Total.replace(/[$,]/g, "")
            );
          }
          if (
            item.InvoiceStatusDescription == "ANTICIPO" &&
            transfersType.includes(item.DescPaymentType)
          ) {
            this.totalTransferAnticipo += parseFloat(
              item.Total.replace(/[$,]/g, "")
            );
          }
          if (
            item.InvoiceStatusDescription == "ANTICIPO" &&
            item.DescPaymentType == "Cheque"
          ) {
            this.totalCheckAnticipo += parseFloat(
              item.Total.replace(/[$,]/g, "")
            );
          }

          if (
            item.InvoiceStatusDescription == "ABONO" &&
            billsAndCoinsAnticipoType.includes(item.DescPaymentType)
          ) {
            this.totalBillsAndCoinsAbonos += parseFloat(
              item.Total.replace(/[$,]/g, "")
            );
          }
          if (
            item.InvoiceStatusDescription == "ABONO" &&
            cardsType.includes(item.DescPaymentType)
          ) {
            this.totalCardsAbonos += parseFloat(
              item.Total.replace(/[$,]/g, "")
            );
          }
          if (
            item.InvoiceStatusDescription == "ABONO" &&
            transfersType.includes(item.DescPaymentType)
          ) {
            this.totalTransferAbonos += parseFloat(
              item.Total.replace(/[$,]/g, "")
            );
          }
          if (
            item.InvoiceStatusDescription == "ABONO" &&
            item.DescPaymentType == "Cheque"
          ) {
            this.totalCheckAbonos += parseFloat(
              item.Total.replace(/[$,]/g, "")
            );
          }

          if (item.InvoiceStatusDescription == "Cancelada") {
            this.totalContadoGeneral += parseFloat(
              item.Total.replace(/[$,]/g, "")
            );
          } else if (item.InvoiceStatusDescription == "ABONO") {
            this.totalAbonoGeneral += parseFloat(
              item.Total.replace(/[$,]/g, "")
            );
          } else if (item.InvoiceStatusDescription == "ANTICIPO") {
            this.totalAnticipos += parseFloat(item.Total.replace(/[$,]/g, ""));
          } else if (item.InvoiceStatusDescription == "Crédito") {
            this.totalCreditoGeneral += parseFloat(
              item.Total.replace(/[$,]/g, "")
            );
          } else if (
            item.InvoiceStatusDescription == "INVALIDADO" ||
            item.InvoiceStatusDescription == "NOTA DE CREDITO" ||
            item.InvoiceStatusDescription == "NOTA DE DEBITO"
          ) {
            this.totalInvalidadoGeneral += parseFloat(
              item.Total.replace(/[$,]/g, "")
            );
          }

          if (item.DescPaymentType == "Billetes y monedas") {
            this.totalBillsAndCoinsGeneral += parseFloat(item.TotalSale);
          } else if (
            ["Tarjeta Débito", "Tarjeta Crédito", 'Tarjeta de crédito / Débito'].includes(item.DescPaymentType)
          ) {
            if (item.DescPaymentType === "Tarjeta Débito") {
              this.totalDebitCard += parseFloat(item.TotalSale);
            } else {
              this.totalCreditCard += parseFloat(item.TotalSale);
            }
            this.totalCardsGeneral += parseFloat(item.TotalSale);
          } else if (item.DescPaymentType == "Cheque") {
            this.totalCheckGeneral += parseFloat(item.TotalSale);
          } else if (
            item.DescPaymentType == "Transferencia_ Depósito Bancario"
          ) {
            this.totalTransferGeneral += parseFloat(item.TotalSale);
          } else {
            this.totalOthersGeneral += parseFloat(item.TotalSale);
          }
        });

        this.subTotal = parseFloat(
          this.totalTransferGeneral +
            this.totalCardsGeneral +
            this.totalBillsAndCoinsGeneral +
            this.totalCheckGeneral
        ).toFixed(2);
        this.totalCreditCard = parseFloat(this.totalCreditCard).toFixed(2);
        this.totalDebitCard = parseFloat(this.totalDebitCard).toFixed(2);
        this.totalContadoGeneral = parseFloat(this.totalContadoGeneral).toFixed(
          2
        );
        this.totalAbonoGeneral = parseFloat(this.totalAbonoGeneral).toFixed(2);
        this.totalInvalidadoGeneral = parseFloat(
          this.totalInvalidadoGeneral
        ).toFixed(2);
        this.totalCreditoGeneral = parseFloat(this.totalCreditoGeneral).toFixed(
          2
        );
        this.totalBillsAndCoinsGeneral = parseFloat(
          this.totalBillsAndCoinsGeneral
        ).toFixed(2);
        this.totalCardsGeneral = parseFloat(this.totalCardsGeneral).toFixed(2);
        this.totalCheckGeneral = parseFloat(this.totalCheckGeneral).toFixed(2);
        this.totalTransferGeneral = parseFloat(
          this.totalTransferGeneral
        ).toFixed(2);
        this.totalOthersGeneral = parseFloat(this.totalOthersGeneral).toFixed(
          2
        );
      } catch (error) {
        console.log("calculateTotalsCashierCut ", error.message);
      }
    },
    hasTypeItem(type, indexPage) {
      // Verificar si existe una página en el índice dado y si contiene la categoría deseada
      return (
        this.valuesRows[indexPage] &&
        this.valuesRows[indexPage].some((item) => item.Categoria === type)
      );
    },
    filterByCategory(type, items) {
      return items.filter((item) => item.Categoria === type);
    },
    calculatePagesOfDoc() {
      let pages = 0;
      let rows = 0;
      const maxRowsPerPage = 48;
      this.valuesRows[pages] = [];
      this.subTotal = 0;
      this.totalIngresos = 0;
      this.totalCredito = 0;
      this.totalEgresos = 0;
      this.total = 0;

      try {
        const body = this.dataProps.data.body;

        const categories = {
          CONTADO: [],
          INGRESOS: [],
          EGRESOS: [],
          INVALIDACIONES: [],
          CREDITO: [],
          ANTICIPO: [],
        };

        body.forEach((item) => {
          if (
            (item.ID_Invoice.includes("FCF") ||
              item.ID_Invoice.includes("CCF") ||
              item.ID_Invoice.includes("FEX")) &&
            item.InvoiceStatusDescription == "Cancelada"
          ) {
            categories["CONTADO"].push(item);
          } else if (
            (item.ID_Invoice.includes("FCF") ||
              item.ID_Invoice.includes("CCF") ||
              item.ID_Invoice.includes("FEX") ||
              item.ID_Invoice.includes("RCIB")) &&
            item.InvoiceStatusDescription != "Cancelada" &&
            item.InvoiceStatusDescription != "INVALIDADO" &&
            item.InvoiceStatusDescription != "Crédito" &&
            item.InvoiceStatusDescription != "ANTICIPO"
          ) {
            this.totalIngresos += parseFloat(item.Total.replace(/[$,]/g, ""));
            categories["INGRESOS"].push(item);
          } else if (
            (item.ID_Invoice.includes("FCF") ||
              item.ID_Invoice.includes("CCF") ||
              item.ID_Invoice.includes("FEX") ||
              item.ID_Invoice.includes("RCIB")) &&
            item.InvoiceStatusDescription == "Crédito"
          ) {
            this.totalCredito += parseFloat(item.Total.replace(/[$,]/g, ""));
            categories["CREDITO"].push(item);
          } else if (
            item.ID_Invoice.includes("FNS") ||
            item.ID_Invoice.includes("DNC") ||
            item.ID_Invoice.includes("DND") ||
            item.InvoiceStatusDescription.includes("INVALIDADO")
          ) {
            if (!item.InvoiceStatusDescription.includes("INVALIDADO")) {
              this.totalEgresos += Math.abs(
                parseFloat(item.Total.replace(/[$,]/g, ""))
              );
            } else {
              this.totalEgresos += Math.abs(
                parseFloat(
                  (
                    (item.sum === 1 && item.abonado === 0
                      ? item.Total
                      : `${item.abonado}`) ?? 0
                  ).replace(/[$,]/g, "")
                )
              );
            }
            categories["EGRESOS"].push(item);
          } else if (item.InvoiceStatusDescription == "ANTICIPO") {
            this.totalIngresos += parseFloat(item.Total.replace(/[$,]/g, ""));
            categories["ANTICIPO"].push(item);
          }
          // if( item.InvoiceStatusDescription == "INVALIDADO" ) {
          //     categories["INVALIDACIONES"].push(item)
          // }
        });

        const processCategory = (group, type) => {
          for (const item of group) {
            if (
              !this.valuesRows[pages].some(
                (element) => element.Categoria === type
              )
            ) {
              rows = rows + 3;
            }

            if (rows >= maxRowsPerPage) {
              pages++;
              rows = 0;
              this.valuesRows[pages] = [];
            }
            // Añadir el registro al arreglo de la página actual
            item.Categoria = type;

            // console.log('pages', pages + 1);
            // console.log('rows', rows);
            // console.log('type', type, item.Total);
            this.valuesRows[pages].push(item);
            // console.log('item', item);

            // En estas condicionales se intenta contabilizar el número de filas que puede ocupar el item
            if (
              item.InvoiceName.length > 37 &&
              item.CodigoGeneracion != "" &&
              item.Categoria !== "CREDITO"
            ) {
              rows = rows + 2;
            } else {
              rows++;
            }
            // console.log('rows', rows);
          }
        };

        processCategory(categories["CONTADO"], "CONTADO");
        processCategory(categories["INGRESOS"], "INGRESOS");
        processCategory(categories["ANTICIPO"], "ANTICIPO");
        processCategory(categories["CREDITO"], "CREDITO");
        processCategory(categories["EGRESOS"], "EGRESOS");
        // processCategory(categories["INVALIDACIONES"], "INVALIDACIONES");

        // console.log('pages', pages + 1);
        // console.log('rows', rows);
        if (rows > 20) {
          pages++;
          this.valuesRows.push([]);
        }

        this.calculateTotalsCashierCut(body);

        this.total = parseFloat(
          parseFloat(this.subTotal) - this.totalEgresos
        ).toFixed(2);
        this.subTotal = parseFloat(this.subTotal).toFixed(2);
        this.totalIngresos = parseFloat(this.totalIngresos).toFixed(2);
        this.totalCredito = parseFloat(this.totalCredito).toFixed(2);
        this.totalEgresos = parseFloat(this.totalEgresos).toFixed(2);
      } catch (err) {
        alert(err);
      }
      pages = pages + 1;
      this.numPages = pages;
    },

    async Print() {
      this.loading = true;
      var doc = new jsPDF("p", "pt", "letter");
      await doc.html(this.$refs.dataprint, {
        callback: function (doc) {
          doc.output();
        },
        x: 0,
        y: 0,
        margin: [0, 0, 0, 0],
        html2canvas: {
          scale: 0.612,
          useCORS: true,
          logging: false,
          allowTaint: true,
        },
      });

      //doc.deletePage(2)

      doc.autoPrint({ variant: "non-conform" });
      const blob = doc.output("bloburl");
      window.open(blob);

      this.loading = false;
    },

    async Download() {
      this.loading = true;
      var doc = new jsPDF("p", "pt", "letter");
      await doc.html(this.$refs.dataprint, {
        callback: function (doc) {
          doc.output();
        },
        x: 0,
        y: 0,
        margin: [0, 0, 0, 0],
        html2canvas: {
          scale: 0.612,
          useCORS: true,
          logging: false,
          allowTaint: true,
        },
      });

      //doc.deletePage(2)
      doc.save("CorteDeCajaDiario.pdf");

      this.loading = false;
    },
    documentTypeByPrefix(prefijo) {
      if(prefijo == 'FCF') return "FACTURA CONSUMIDOR FINAL";
      if(prefijo == 'CCF') return "COMPROBANTE DE CRÉDITO FISCAL";
      if(prefijo == 'FNS') return "FACTURA SUJETO EXCLUIDO";
      if(prefijo == 'FEX') return "FACTURA DE EXPORTACIÓN";
      if(prefijo == 'DNC') return "NOTA DE CRÉDITO";
      if(prefijo == 'DND') return "NOTA DE DÉBITO";
      if(prefijo == 'CDD') return "COMPROBANTE DE DONACIÓN";
      if(prefijo == 'DNR') return "NOTA DE REMISIÓN";
      if(prefijo == 'CAP') return "ANTICIPOS";
      if(prefijo == 'RCIB') return "ABONOS";
      if(prefijo == 'TCKS') return "TICKETS";
      return prefijo
    },
  },
};
</script>

<style scoped>
.u-row .u-col-100 {
  width: 100% !important;
}
.btnclean {
  border-radius: 15px;
  border: 1px solid white;
  background-color: #f29d35 !important;
  color: white !important;
}
.btnclose {
  border-radius: 15px;
  border: 1px solid white;
  background-color: rgb(255, 38, 38) !important;
  color: white !important;
}

* {
  font-family: Arial, Helvetica, sans-serif !important;
}
</style>
